import { render } from "./ReviewFormlist.vue?vue&type=template&id=1320c067&scoped=true"
import script from "./ReviewFormList.js?vue&type=script&lang=js"
export * from "./ReviewFormList.js?vue&type=script&lang=js"

import "./ReviewFormlist.vue?vue&type=style&index=0&id=1320c067&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1320c067"]])

export default __exports__